import { createFileRoute } from '@tanstack/react-router'

import { FederalTaxListPage } from '@/features/federal-tax'

export const Route = createFileRoute('/_shell/federal-tax/')({ component: FederalTaxListPage })
